import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { LoginToWizardSuiteServiceResponse } from "./loginToWizardSuite.service";

export const loginToWizardSuiteEndpoint = (): AxiosPromise<LoginToWizardSuiteServiceResponse> =>
    apiWrapper.instance!.get(`rest/wizard/authentication/loginToWizardSuite`);
